import { LoaderCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showContainer?: boolean;
}

export function LoadingSpinner({
  className,
  size = "md",
  showContainer = true,
}: LoadingSpinnerProps = {}) {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
  };

  const spinner = (
    <LoaderCircle
      className={cn("animate-spin text-gray-400", sizeClasses[size], className)}
    />
  );

  if (!showContainer) {
    return spinner;
  }

  return (
    <div className="flex items-center justify-center h-full min-h-[200px]">
      {spinner}
    </div>
  );
}
